import { render, staticRenderFns } from "./MaInNavigationSidebar.vue?vue&type=template&id=bb7ff794&"
import script from "./MaInNavigationSidebar.vue?vue&type=script&lang=js&"
export * from "./MaInNavigationSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports